import React from 'react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://dog-calm.systeme.io/dogcalm';
export function HeroSection() {
  const goToCheckout = () => {
    trackAddToCart();
    window.location.href = CHECKOUT_URL;
  };
  return <section id="hero" className="pt-4 pb-12 px-5" data-id="element-180">
      <div className="max-w-lg mx-auto flex flex-col items-center text-center animate-fade-in-up" data-id="element-181">
        {/* Eyebrow */}
        <div className="inline-block px-3 py-1 mb-6 rounded-full glass border-accent/30" data-id="element-182">
          <span className="text-xs font-bold tracking-widest text-accent uppercase" data-id="element-183">
            MÉTODO PROBADO EN CIUDAD 2026
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-2xl md:text-4xl font-bold text-white mb-8 leading-tight" data-id="element-184">
          ¿Siente que su perro entra en un estado de{' '}
          <strong className="text-accent" data-id="element-185">bloqueo</strong> y{' '}
          <strong className="text-accent" data-id="element-186">falta de foco</strong> en cuanto pisa
          la calle?
        </h1>

        {/* Hero Image with Discount Badge */}
        <div className="w-full mb-8 relative" data-id="element-187">
          <div className="absolute inset-0 bg-accent/20 blur-3xl rounded-full -z-10 transform scale-90" data-id="element-188"></div>
          {/* Discount Badge */}
          <div className="absolute top-3 right-3 z-20 bg-red-600 text-white font-extrabold text-sm px-3 py-2 rounded-xl shadow-lg border-2 border-white/30 rotate-3" data-id="element-189">
            -63% DTO.
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/jbKKtR8zYbHRy1zEq9N1tf/mockup_nuevo.png" alt="DOG-CALM Pack Completo" className="w-full h-auto rounded-2xl shadow-2xl border border-teal/20" data-id="element-190" />
        </div>

        {/* Sub-headline */}
        <p className="text-lg text-white/70 mb-8 leading-relaxed" data-id="element-191">
          Activa el protocolo biológico de 7 días para silenciar el cortisol y
          recuperar una correa en sonrisa. Sin fuerza, sin tirones.
        </p>

        {/* Social Proof Bar */}
        <div className="w-full mb-6 py-2.5 px-4 rounded-full bg-white/5 border border-white/10" data-id="element-192">
          <p className="text-white/80 text-sm font-medium text-center" data-id="element-193">
            ⭐⭐⭐⭐⭐ +450 comentarios positivos esta semana.
          </p>
        </div>

        {/* Price Display */}
        <div className="mb-4" data-id="element-194">
          <div className="flex items-center justify-center gap-3" data-id="element-195">
            <span className="text-white/40 line-through text-xl" data-id="element-196">27,00€</span>
            <span className="text-white font-black text-4xl" data-id="element-197">9,95€</span>
          </div>
        </div>

        {/* Trust Icons */}
        <div className="flex items-center justify-center gap-4 mb-6 flex-wrap" data-id="element-198">
          <span className="text-white/60 text-xs font-medium flex items-center gap-1" data-id="element-199">
            📥 Entrega Inmediata
          </span>
          <span className="text-white/60 text-xs font-medium flex items-center gap-1" data-id="element-200">
            ♾️ Acceso de por vida
          </span>
          <span className="text-white/60 text-xs font-medium flex items-center gap-1" data-id="element-201">
            ✅ Garantía 14 días
          </span>
        </div>

        {/* CTA */}
        <div className="w-full flex flex-col items-center gap-3" data-id="element-202">
          <Button onClick={goToCheckout} fullWidth className="animate-pulse-soft" data-id="element-203">
            SÍ, QUIERO PASEOS EN CALMA
          </Button>
          <p className="text-white/70 text-sm font-medium" data-id="element-204">
            Pago único. Acceso inmediato. ⭐ 4.9/5 valoración real.
          </p>
        </div>
      </div>
    </section>;
}